import { render, staticRenderFns } from "./BuySellOfferForm.vue?vue&type=template&id=21df927b&scoped=true"
import script from "./BuySellOfferForm.vue?vue&type=script&lang=ts"
export * from "./BuySellOfferForm.vue?vue&type=script&lang=ts"
import style0 from "./BuySellOfferForm.vue?vue&type=style&index=0&id=21df927b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21df927b",
  null
  
)

export default component.exports